import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import type { UseFormReturn } from 'react-hook-form'
import { useController } from 'react-hook-form'

export default function useEnsureGeoPlace(
  methods: UseFormReturn<any>,
  placeKey: string,
  depKeys: Array<string>,
  enabled: boolean = true,
) {
  const intl = useIntl()
  const geoErrorMsg = intl.formatMessage({
    id: 'tP0qm0Qg1Ty4YT973b4x',
    defaultMessage: 'Please select an address or place.',
    description: 'Validation error when no geo place is selected in trip planner form',
  })

  const pointKey = `${placeKey}.point`
  const { clearErrors, control, setError, formState, watch, getValues } =
    methods
  const type = watch('type')

  const {
    fieldState: { error },
  } = useController({
    name: pointKey,
    control,
    shouldUnregister: true,
    rules: {
      required: geoErrorMsg,
    },
  })

  useEffect(() => {
    clearErrors(depKeys)
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [type])

  useEffect(() => {
    if (error?.message) {
      for (const name of depKeys) {
        if (getValues(name)?.length > 0) {
          if (enabled) {
            setError(name, {
              type: 'deps',
              message: geoErrorMsg,
            })
          }
        }
      }
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [error?.message, depKeys, formState.submitCount])

  return error
}
